import React from "react";
import { Button, Card, Modal, Row } from "react-bootstrap";
import FileUploadComponent from "../../components/FileUploadComponent";
import DownloadIcon from "@mui/icons-material/Download";
import PrimaryButton from "../../components/PrimaryButton";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReconciliationStatus } from "../../constants/ReconciliationStatus";
import moment from "moment-timezone"
import i18n from "../../constants/Strings";


const DiscrepanciesStatus = ({
    reconciliationStatus,
    message,
    startDate,
    endDate,
    setEndDate,
    setUploadFile,
    enableUpload,
    onContinue,
    onApproveOrReject,
    downloadReconciliationfile,
    reconciliationFile,
    setShowConfirmationModal,
    showConfirmationModal,
    setApprovalStatus,
    uploadFile,
    fileName,
    setFileName,
    downloadSampleCSV,


}) => {
    switch (reconciliationStatus) {

        case ReconciliationStatus.COMPUTING_DISCREPANCIES:
        case ReconciliationStatus.RESOLVING_DISCREPANCIES:
            return <Processing />;
        case ReconciliationStatus.COMPUTING_DISCREPANCIES_FAILED:
        case ReconciliationStatus.RESOLVING_DISCREPANCIES_FAILED:
        case ReconciliationStatus.RESOLVING_DISCREPANCIES_SUCCESS:
        case ReconciliationStatus.NO_DESCREPANCIES_FOUND:
            return <UploadReconciliation
                message={message}
                startDate={startDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setUploadFile={setUploadFile}
                enableUpload={enableUpload}
                onContinue={onContinue}
                uploadFile={uploadFile}
                fileName={fileName}
                setFileName={setFileName}
                downloadSampleCSV={downloadSampleCSV}
            />;
        case ReconciliationStatus.COMPUTING_DISCREPANCIES_SUCCESS:
            return <ConfirmStatus
                onApproveOrReject={onApproveOrReject}
                downloadReconciliationfile={downloadReconciliationfile}
                reconciliationFile={reconciliationFile}
                setShowConfirmationModal={setShowConfirmationModal}
                showConfirmationModal={showConfirmationModal}
                setApprovalStatus={setApprovalStatus} />;
        default:
            return <UploadReconciliation
                message={message}
                startDate={startDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setUploadFile={setUploadFile}
                enableUpload={enableUpload}
                onContinue={onContinue}
                uploadFile={uploadFile}
                fileName={fileName}
                setFileName={setFileName}
                downloadSampleCSV={downloadSampleCSV}
            />;
    }
};

export default DiscrepanciesStatus;


const Processing = () => {

    const text = {
        processing: i18n.t('reconciliation.discrepanciesStatus.processing'),
    }

    return (

        <div className="d-flex justify-content-center align-items-center mt-5">
            <h4 className="txt-primary">{text.processing}</h4>
        </div>
    )
};

const UploadReconciliation = ({
    message,
    startDate,
    endDate,
    setEndDate,
    setUploadFile,
    enableUpload,
    onContinue,
    uploadFile,
    fileName,
    setFileName,
    downloadSampleCSV

}) => {

    const text = {
        rulesHeading: i18n.t('reconciliation.discrepanciesStatus.uploadReconciliation.rulesHeading'),
        rulesToUpload: i18n.t('reconciliation.discrepanciesStatus.uploadReconciliation.rulesToUpload'),
        sampleCSV: i18n.t('reconciliation.discrepanciesStatus.uploadReconciliation.sampleCSV'),
        downloadBtn: i18n.t('reconciliation.discrepanciesStatus.uploadReconciliation.downloadBtn'),
        fileTemplateHeading: i18n.t('reconciliation.discrepanciesStatus.uploadReconciliation.fileTemplateHeading'),
        startDate: i18n.t('reconciliation.discrepanciesStatus.uploadReconciliation.startDate'),
        endDate: i18n.t('reconciliation.discrepanciesStatus.uploadReconciliation.endDate'),
        file: i18n.t('reconciliation.discrepanciesStatus.uploadReconciliation.file'),
        uploadBtn: i18n.t('reconciliation.discrepanciesStatus.uploadReconciliation.uploadBtn'),
    }
    return (
        <>
            <div className="col-md">
                <Card className="p-3">
                    <h5>{text.rulesHeading}</h5>
                    <ul className="p-2">
                        {text.rulesToUpload.map((rule, index) => (
                            <li key={index}>
                                <p className="text-left text-secondary">{rule}</p>
                            </li>
                        ))}
                    </ul>
                    <div className="row">
                        <div className="col">
                            <h5 className="text-left">{text.fileTemplateHeading}</h5>
                            <h6 className="text-left text-secondary">
                                {text.sampleCSV}
                            </h6>
                        </div>
                        <div className="col d-flex align-items-center justify-content-end">
                            <a
                                className="text-dark"
                                href="#"
                                onClick={downloadSampleCSV}
                            >
                                {text.downloadBtn}
                            </a>
                        </div>
                    </div>
                </Card>
            </div>
            <div className="col-md mt-3">
                {message && <h4 className="txt-primary my-3">*{message}</h4>}
                <div className="col-md">
                    <Row>
                        <div className="d-flex col-md-12 justify-content-center">
                            <div className="d-flex justify-content-between mr-5 align-items-center">
                                <h6 className="mt-3 align-items-center">{text.startDate}</h6>
                                <DatePicker
                                    disabled
                                    placeholderText={startDate}
                                    className="form-control ml-3" />
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <h6 className="mt-3 align-items-center">{text.endDate}</h6>
                                <DatePicker
                                    minDate={moment(startDate, "DD/MM/YYYY").toDate()}
                                    selected={endDate}
                                    onChange={(date) => {
                                        setEndDate(moment(date).format("YYYY-MM-DDTHH:mm:ssZ"))
                                    }}
                                    dateFormat={"dd/MM/yyyy"}
                                    className="form-control ml-3 " />
                            </div>
                        </div>
                    </Row>
                    <Row>
                        <div className=" d-flex align-items-center justify-content-center mt-3">
                            <h6 className=" align-items-center mr-3">{text.file}</h6>
                            <div className="w-50">

                                <FileUploadComponent
                                    key={uploadFile ? uploadFile.name : ""}
                                    setSelectedFile={setUploadFile}
                                    setFileName={setFileName}
                                    fileName={fileName}
                                    fileType={".csv"}
                                />
                            </div>

                        </div>

                    </Row>
                    <PrimaryButton
                        disabled={!enableUpload}
                        type="submit"
                        text={text.uploadBtn}
                        className="mt-2 justify-content-center width-auto"
                        onClick={onContinue}
                    />
                </div>
            </div>
        </>
    )
};

const ConfirmStatus = ({
    onApproveOrReject,
    downloadReconciliationfile,
    reconciliationFile,
    setShowConfirmationModal,
    showConfirmationModal,
    setApprovalStatus
}) => {

    const text = {
        confirmation: i18n.t('reconciliation.discrepanciesStatus.confirmStatus.confirmation'),
        confirmationMessage: i18n.t('reconciliation.discrepanciesStatus.confirmStatus.confirmationMessage'),
        cancel: i18n.t('reconciliation.discrepanciesStatus.confirmStatus.cancel'),
        confirm: i18n.t('reconciliation.discrepanciesStatus.confirmStatus.confirm'),
        processedFile: i18n.t('reconciliation.discrepanciesStatus.confirmStatus.processedFile'),
        downloadBtn: i18n.t('reconciliation.discrepanciesStatus.confirmStatus.downloadBtn'),
        approveBtn: i18n.t('reconciliation.discrepanciesStatus.confirmStatus.approveBtn'),
        rejectBtn: i18n.t('reconciliation.discrepanciesStatus.confirmStatus.rejectBtn'),
    }
    return showConfirmationModal ? (
        <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{text.confirmation}</Modal.Title>
            </Modal.Header>
            <Modal.Body><strong>{text.confirmationMessage}</strong></Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={() => setShowConfirmationModal(false)} >
                    {text.cancel}
                </Button>
                <Button variant="primary" onClick={onApproveOrReject}>
                    {text.confirm}
                </Button>
            </Modal.Footer>
        </Modal>
    ) : (
        <div className="container">
            <div className="d-flex justify-content-center align-items-center mt-5">
                <h4 className="txt-primary">
                    {text.processedFile}
                </h4>
            </div>
            <PrimaryButton
                text={
                    <>
                        <DownloadIcon /> {text.downloadBtn}
                    </>
                }
                onClick={() => downloadReconciliationfile(reconciliationFile)}
                variant="primary"
                className="mt-5"
            />
            <div className="d-flex justify-content-center align-items-center mt-5 ">
                <PrimaryButton
                    text={text.approveBtn}
                    onClick={() => {
                        setShowConfirmationModal(true)
                        setApprovalStatus(true)
                    }}
                    variant="success"
                    className="mr-5"
                />
                <PrimaryButton
                    text={text.rejectBtn}
                    onClick={() => {
                        setShowConfirmationModal(true)
                        setApprovalStatus(false)
                    }}
                    variant="danger"
                    className="ml-5"
                />
            </div>
        </div>
    );
};